import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

type Request = { title: string; description: string; action: string }

export function usePortariaConfirm() {
  const [request, setRequest] = useState<Request | null>(null)
  const pending = useRef<((result: boolean) => void) | null>(null)
  const box = useRef<HTMLDivElement>(null)
  const cancel = useRef<HTMLButtonElement>(null)

  function finish(result: boolean) {
    pending.current?.(result)
    pending.current = null
    setRequest(null)
  }

  useEffect(() => () => { pending.current?.(false); pending.current = null }, [])
  useEffect(() => {
    if (!request) return
    const previous = document.activeElement instanceof HTMLElement ? document.activeElement : null
    const overflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    cancel.current?.focus()
    function key(event: KeyboardEvent) {
      if (event.key === 'Escape') { event.preventDefault(); finish(false) }
      if (event.key !== 'Tab') return
      const controls = box.current?.querySelectorAll<HTMLButtonElement>('button')
      if (!controls?.length) return
      const first = controls[0], last = controls[controls.length - 1]
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus() }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus() }
    }
    document.addEventListener('keydown', key)
    return () => {
      document.body.style.overflow = overflow
      document.removeEventListener('keydown', key)
      previous?.focus()
    }
  }, [request])

  function confirm(next: Request) {
    pending.current?.(false)
    return new Promise<boolean>(resolve => { pending.current = resolve; setRequest(next) })
  }

  const dialog = request && createPortal(
    <div className="portaria-modal-backdrop" onClick={() => finish(false)}>
      <div ref={box} className="portaria-modal portaria-confirm" role="alertdialog" aria-modal="true" aria-label={request.title} onClick={event => event.stopPropagation()}>
        <span className="portaria-confirm-icon" aria-hidden="true">!</span>
        <h2>{request.title}</h2><p>{request.description}</p>
        <div className="portaria-actions">
          <button ref={cancel} type="button" className="portaria-quiet" onClick={() => finish(false)}>Cancelar</button>
          <button type="button" className="portaria-danger" onClick={() => finish(true)}>{request.action}</button>
        </div>
      </div>
    </div>, document.body,
  )
  return { confirm, dialog }
}
